import { useLang } from "../context/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex items-center rounded-full bg-black/30 p-0.5 text-xs font-heading font-bold ${className}`} data-testid="language-toggle">
      <button
        onClick={() => setLang("it")}
        className={`px-2.5 py-1 rounded-full bouncy transition-colors ${lang === "it" ? "btn-neon" : "text-white/50"}`}
        data-testid="lang-it-btn"
      >
        IT
      </button>
      <button
        onClick={() => setLang("en")}
        className={`px-2.5 py-1 rounded-full bouncy transition-colors ${lang === "en" ? "btn-neon" : "text-white/50"}`}
        data-testid="lang-en-btn"
      >
        EN
      </button>
    </div>
  );
}
